import { render, staticRenderFns } from "./card.vue?vue&type=template&id=271fbf2a&scoped=true"
import script from "./card.vue?vue&type=script&lang=js"
export * from "./card.vue?vue&type=script&lang=js"
import style0 from "./card.vue?vue&type=style&index=0&id=271fbf2a&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271fbf2a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('271fbf2a')) {
      api.createRecord('271fbf2a', component.options)
    } else {
      api.reload('271fbf2a', component.options)
    }
    module.hot.accept("./card.vue?vue&type=template&id=271fbf2a&scoped=true", function () {
      api.rerender('271fbf2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/solution/HealthcareSolutions/components/card.vue"
export default component.exports